<!-- <div *ngIf="deleteConfrimation" class="back-drop"></div>
<div *ngIf="deleteConfrimation" class="confirmation-msg-box">
    <div class="flex-col-center">
        <span class="font18 m-t25 m-lr-25">Do you want to delete this plan?</span>                   
        <span class="blueText16 m-15">{{planNameForDelete}}</span>                   
        
        <div class="flex-1 m-t15" >
                <button mat-raised-button color="basic" (click)=deletePlan(false)>Cancel</button>
                <button mat-raised-button color="primary" class="m-l10" (click)=deletePlan(true)>Delete</button>
            </div> 
    </div>
</div> -->
<!-- <mat-progress-bar *ngIf="showProgress" mode="indeterminate" style="position: absolute; top: 40px; left: 0px;"></mat-progress-bar> -->
<mat-progress-bar class="progress-bar-buffer progress-bar-fill" *ngIf="showProgress" mode="indeterminate" style="position: absolute; top: 40px; left: 0px;"></mat-progress-bar>   
<div class="flex-col-center m-20">
    <!--Start: Client or Account Search -->
    <div class="flex-row-container  wd-95">       
      <div class="flex-col-center flex-1">
          <mat-form-field style="width:400px;">
            <mat-icon matSuffix>search</mat-icon>
            <input  type="text" 
              placeholder="Client or Account Search" 
              aria-label="Client Search" 
              maxlength="30"
              matInput
              style="padding-left: 10px;"
              [formControl]="searchControl" 
              [matAutocomplete]="auto" 
              *ngIf="clientList">
              <mat-autocomplete #auto="matAutocomplete" [panelWidth]="500" class="client-search-autocomplete">
                    <div class="p-10 search__header B">
                        <span>Clients (</span><span>{{((clientList['@odata.count']>=5)? ('5'):(clientList['@odata.count']))}}</span><span> of {{clientList['@odata.count']}})</span>
                    </div>
                    <mat-option  *ngFor="let c of clientList['value']"  [value]="" (onSelectionChange)="onClientSelectionChange(c)">                          
                    <div style="display: flex; flex-direction: row; justify-content: space-between;"  [ngClass]="!(c.legalEntityType==='Individual' || c.legalEntityType==='P')?'red-text':''">
                        <div class="search__advisorId-column"> 
                            <span><mat-icon matPrefix  [ngClass]="!(c.legalEntityType==='Individual' || c.legalEntityType==='P')?'red-text':''">person</mat-icon></span>
                        </div>
                        <div class="search__name-column">
                          <span class="text-truncate">{{c.LegalEntityName}}</span>
                          <span style="font-size: 10px;"><span class="B">{{c.Account.length}}</span> Account(s)</span>   
                        </div>
                        <div class="search__name-column">
                          <span class="text-truncate">{{c.ClientAdvisor}}</span>
                          <span class="text-truncate">{{c.ClientAdvisorTeam}}</span>
                        </div>
                        <div class="search__advisorId-column">
                            <span>{{c.ClientAdvisorID}}</span>
                        </div>
                        <div class="search__amount-column" style="align-items: flex-end;">
                            <span>{{c.ClientKPI && c.ClientKPI.AumTotal | currency }}</span>                             
                          </div>
                      </div>
                    </mat-option> 
                    <div class="p-10 search__header B">
                        <span>Accounts (</span><span>{{((accountList['@odata.count']>=5)? ('5'):(accountList['@odata.count']))}}</span><span> of {{accountList['@odata.count']}})</span>
                    </div>
                    <mat-option  *ngFor="let c of accountList['value']"  [value]="" (onSelectionChange)="onAccountSelectionChange(c)">                          
                      <div style="display: flex; flex-direction: row; justify-content: space-between;" [ngClass]="!(c.legalEntityType==='Individual' || c.legalEntityType==='P')?'red-text':''">
                        <div class="advisorId-column"> 
                            <span><mat-icon matPrefix [ngClass]="!(c.legalEntityType==='Individual' || c.legalEntityType==='P')?'red-text':''">account_balance</mat-icon></span>
                        </div>
                        <div class="search__name-column">
                          <span *ngIf="c.CustodianType && c.CustodianType.toUpperCase()==='INTERNAL'" class="text-truncate">{{(c.gfoCustodyAccount && c.CustodyAccount)?c.CustodyAccount:(c.id | uppercase)}}</span>
                          <span *ngIf="c.CustodianType && c.CustodianType.toUpperCase()==='EXTERNAL'" class="text-truncate">{{c.AccountNickname | uppercase}}</span>                                  
                        </div>
                        <div class="search__name-column">
                          <span class="text-truncate">{{c.ClientAdvisor}}</span>
                          <span class="text-truncate">{{c.ClientAdvisorTeam}}</span>
                        </div>
                        <div class="search__advisorId-column">
                            <span class="text-truncate">{{c.ClientAdvisorID}}</span>
                        </div>
                        <div class="search__amount-column" style="align-items: flex-end;">
                            <span class="text-truncate">{{c.AccountKPIs && c.AccountKPIs.AccountTotal | currency }}</span>                             
                          </div>
                      </div>
                    </mat-option>                                                 
              </mat-autocomplete>
          </mat-form-field>
      </div> 
      <div style="align-self: flex-end;">
        <p><mat-icon class="pointer" style="font-size: 20px;" matTooltip="Reload" [matTooltipPosition]="'above'"  (click)=getPlanList()>refresh</mat-icon></p>
      </div>
    </div>
    <!--End: Client or Account Search -->
    
    <!--Start: Plan List -->
    <div class="flex-row-container wd-95">
      <div class="flex-col-container flex-1">
        <mat-table [dataSource]="dataSource" style="background-color:var(--white); color: var(--neutralPrimary);">
            <ng-container matColumnDef="planName" >
                <mat-header-cell *matHeaderCellDef> PLAN NAME </mat-header-cell>
                <mat-cell class="p-r10 text-truncate" *matCellDef="let element">
                  <a class="openPlanlLink" *ngIf="element.planName && (element.clientType==='Individual' || element.clientType==='P')" [routerLink]="['/plan', element.planId]" [queryParams]= "{cid: element.clientid}">{{element.planName}}</a>
                  <span *ngIf="!element.planName">-</span>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="clientname">
              <mat-header-cell *matHeaderCellDef> CLIENT NAME </mat-header-cell>
              <mat-cell class="p-r10 text-truncate" *matCellDef="let element"> {{element.clientname?element.clientname:''}} </mat-cell>
            </ng-container>

            <!-- <ng-container matColumnDef="plantype">
                <mat-header-cell *matHeaderCellDef> Type </mat-header-cell>
                <mat-cell class="p-r10 text-truncate" *matCellDef="let element"> {{element.plantype?element.plantype:'-'}} </mat-cell>
            </ng-container> -->

            <ng-container matColumnDef="createddatetime">
                <mat-header-cell *matHeaderCellDef> CREATED ON </mat-header-cell>
                <mat-cell class="p-r10" *matCellDef="let element"> 
                    <div class="flex-col-container">
                        <span>{{element.createddatetime?(element.createddatetime  | date: 'MM/dd/y'):'-'}}</span>
                        <span class="blueText14 text-truncate pointer" [matTooltip]="element.createdby">{{element.createdby}}</span>
                    </div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="updateddatetime" >
                <mat-header-cell *matHeaderCellDef> LAST UPDATED ON </mat-header-cell>
                <mat-cell class="p-r10" *matCellDef="let element" >
                    <div class="flex-col-container">
                        <span>{{element.updateddatetime?(element.updateddatetime  | date: 'MM/dd/y'):'-'}}</span>
                        <span class="blueText14 text-truncate pointer" [matTooltip]="element.updatedby">{{element.updatedby}}</span>                        
                    </div>
                </mat-cell>
            </ng-container>
            
            <ng-container matColumnDef="actions">
                    <mat-header-cell  *matHeaderCellDef ></mat-header-cell>
                    <mat-cell *matCellDef="let element" >
                      <!-- <a mat-button class="font16 B" style="color: #037F8C" *ngIf="element.clientType==='Individual' || element.clientType==='P'" [routerLink]="['/plan', element.planId]" [queryParams]= "{cid: element.clientid}">{{element.planId && element.planId.trim()?'':'CREATE PLAN'}}</a> -->
                      <a mat-raised-button color="primary" *ngIf="element.clientType==='Individual' || element.clientType==='P'" [routerLink]="['/plan', element.planId]" [queryParams]= "{cid: element.clientid}">{{element.planId && element.planId.trim()?'':'Create Plan'}}</a>
                      <div *ngIf="element.planId && element.planId.trim()">
                        <mat-icon *ngIf="element.createdby === loggedInUserId" class="pointer" style="color: var(--primaryTheme)" matTooltipClass="tooltip" matTooltip="Delete" matTooltipPosition ="right" (click)="deletePlan(element.planId, element.planName)">delete</mat-icon>
                        <mat-icon *ngIf="element.createdby !== loggedInUserId" style="color: var(--neutralQuaternary)" matTooltipClass="tooltip" matTooltip="You are not authorized to delete this plan. Please contact {{element.createdby}}" matTooltipPosition ="right" >delete</mat-icon>
                      </div>
                      <div class="flex-row-container" *ngIf="!(element.clientType==='Individual' || element.clientType==='P')">
                        <span class="red-text m-t2">Business or Trust Client</span>
                        <mat-icon class="m-l3 pointer" matTooltipPosition ="below" matTooltipClass="tooltip" [matTooltip]="buinessClientTooltip">info</mat-icon>
                      </div>                      
                    </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>        
      </div>
      <!-- <button mat-raised-button color="primary" [routerLink]="['../plan']">Go to Plan Dashboard</button> -->
    </div>   
    <!--End: Plan List -->
</div>